export default "__VITE_ASSET__c8acebfa__"